<template>
  <div id="Opportunities_Internships">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>

    <usc-intro>
      <p slot="p">Nearly all Marshall undergraduates intern during their four years at the school — with 34% of all students earning three or more internships. These real-world learning opportunities are available to you on virtually every continent and field within the business world.</p>
    </usc-intro>

    <div class="body mb gutter-lg">
      <p>Internships give you practical training, exposure to different business sectors, the opportunity to develop new skills and contacts, and personal and professional growth. You can also explore multiple industries and roles by interning, for instance, in entertainment one summer and at an investment bank the next to learn what type of career suits you best.</p>
      <img src="../../../static/internships-24.png" alt="infographic: 91% have 1+ internship and 34% have 3+ internships" style="width: 100%;"/>
    </div>
      <usc-dataviz :data="dataViz">
      <h3 slot="title">A majority of Marshall undergraduates pursue multiple internships</h3>
      <!-- <svg slot="svg" class="scaling-svg" xmlns="http://www.w3.org/2000/svg" width="322" height="322" viewBox="0 0 322 322"><path id="0" fill="#777" d="M150, 0 A150,150 0 0 1 265.58299376779485,245.60633635734553 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="1" fill="#CCC" d="M265.58299376779485, 245.60633635734553 A150,150 0 0 1 18.56244912085134,222.27842153015797 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="2" fill="#900" d="M18.56244912085134, 222.27842153015797 A150,150 0 0 1 61.813151230087655,28.66130170455672 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="3" fill="#ffcc01" d="M61.813151230087655, 28.66130170455672 A150,150 0 0 1 103.62379780971771,7.3492100603503445 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="4" fill="#fff" d="M103.62379780971771, 7.3492100603503445 A150,150 0 0 1 149.9738200613531,0.000002284630625126738 L150,150 A0,0 0 0 0 150,150 Z"></path></svg> -->
      <!-- <svg slot="svg" class="scaling-svg" xmlns="http://www.w3.org/2000/svg" id="sv" width="300" height="300" viewBox="0 0 300 300"><path id="0" fill="#fc0" d="M150, 0 A150,150 0 0 1 253.4101980328874,258.656941530668 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="1" fill="#900" d="M253.4101980328874, 258.656941530668 A150,150 0 0 1 5.892071568157576,191.628175111131 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="2" fill="#cbcbcb" d="M5.892071568157576, 191.628175111131 A150,150 0 0 1 101.27162208125858,8.135468895821901 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="3" fill="#777777" d="M101.27162208125858, 8.135468895821901 A150,150 0 0 1 149.9738200613531,0.000002284630625126738 L150,150 A0,0 0 0 0 150,150 Z"></path></svg> -->
      <!-- <svg slot="svg" class="scaling-svg" xmlns="http://www.w3.org/2000/svg" id="sv" width="300" height="300" viewBox="0 0 300 300"><path id="0" fill="#fc0" d="M150, 0 A150,150 0 0 1 265.58299376779485,245.60633635734553 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="1" fill="#900" d="M265.58299376779485, 245.60633635734553 A150,150 0 0 1 18.56244912085134,222.27842153015797 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="2" fill="#cbcbcb" d="M18.56244912085134, 222.27842153015797 A150,150 0 0 1 61.813151230087655,28.66130170455672 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="3" fill="#777777" d="M61.813151230087655, 28.66130170455672 A150,150 0 0 1 149.9738200613531,0.000002284630625126738 L150,150 A0,0 0 0 0 150,150 Z"></path></svg> -->
      <svg slot="svg" class="scaling-svg" xmlns="http://www.w3.org/2000/svg" id="sv" width="300" height="300" viewBox="0 0 300 300"><path id="0" fill="#fc0" d="M150, 0 A150,150 0 0 1 238.17625963515837,271.34639358775 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="1" fill="#900" d="M238.17625963515837, 271.34639358775 A150,150 0 0 1 0.2972084347992734,159.43791277699 L150,150 A0,0 0 0 0 150,150 Z"></path><path id="2" fill="#cbcbcb" d="M0.2972084347992734, 159.43791277699 A150,150 0 0 1 149.9738200613531,0.000002284630625126738 L150,150 A0,0 0 0 0 150,150 Z"></path></svg>
      </usc-dataviz>
      <path id="0" fill="#777" d="M90, 0 A90,90 0 0 1 159.34979626067692,147.3638018144073 L90,90 A0,0 0 0 0 90,90 Z"></path><path id="1" fill="#CCC" d="M159.34979626067692, 147.3638018144073 A90,90 0 0 1 11.137469472510801,133.3670529180948 L90,90 A0,0 0 0 0 90,90 Z"></path><path id="2" fill="#900" d="M11.137469472510801, 133.3670529180948 A90,90 0 0 1 37.08789073805259,17.19678102273403 L90,90 A0,0 0 0 0 90,90 Z"></path><path id="3" fill="#ffcc01" d="M37.08789073805259, 17.19678102273403 A90,90 0 0 1 62.17427868583063,4.409526036210195 L90,90 A0,0 0 0 0 90,90 Z"></path><path id="4" fill="#fff" d="M62.17427868583063, 4.409526036210195 A90,90 0 0 1 89.98429203681187,0.0000013707783779182137 L90,90 A0,0 0 0 0 90,90 Z"></path>
    <div class="body mb gutter-lg">
      <p>At Marshall, our top priority is supporting student success. We employ myriad resources to facilitate your personal growth and career and leadership development. Throughout the year, we host networking opportunities and special recruitment events, connecting students, faculty and alumni with representatives from the world’s most storied companies. At Marshall, you’ll engage with prospective employers through speaker series, corporate conferences, mentoring programs and in-classroom guest lecturers. We also maintain an extensive database of job and internship opportunities.</p>
      <p>The university’s annual Career Fest centers on success in every step of your career-development journey and features panels and workshops that help you gain an inside perspective on what hiring managers look for in internship and job candidates.</p>
      <p>The extensive Trojan network is only one resource to help you find your dream job. Here are a few other resources:</p>
      <p><strong>Career Advantage Program</strong><br />
        Designed to bring together USC Marshall undergraduates and business professionals, many of whom are Marshall alumni, the Career Advantage Program (CAP) builds supportive relationships that maximize students’ potential. Through CAP, alumni mentors offer academic and career guidance, share personal experiences, strengthen your professional network, provide a link to the business world, and help you hone interview and job skills.
      </p>
      <p><strong>CAP participants each year:</strong></p>
      <img src="../../../static/info-ADVANTAGES-internships-career-services.png" alt="Infographic: 350+ Students 125+ Mentors 3 Number of years students can participate." title="Infographic: 350+ Students 125+ Mentors 3 Number of years students can participate." style="width: 100%;" />
      <p><strong>USC Marshall Career Source</strong><br />The USC Marshall Career Source is a database available to all Marshall and Leventhal undergraduates. The Career Source lists internship and job postings, notes upcoming career development programs and student organization events and provides helpful career guidance for students interested in all aspects of business and accounting.</p>
      <p><strong>Corporate Advisory Board</strong><br />The USC Marshall Corporate Advisory Board (CAB) is composed of senior-level executives from major corporations from around the world. Their purpose is to support the research and education mission at Marshall. CAB serves as a crucial link between the school and the international corporate business community and provides input on the strategic direction of the school.</p>
      <p><strong>USC Career Center</strong><br />Marshall is proud to partner with the USC Career Center, which provides lifelong services including résumé-writing workshops, job search strategy sessions, on-campus interviews, recruitment fairs, an alumni database, career counseling and information about specific industry trends. The center also offers access to extraordinary domestic and international internship opportunities.</p>
    </div>
    <usc-table :title="this.table.title" :data="this.table.data" :disclaimer="this.table.disclaimer"></usc-table>
    <!-- <usc-table :title="this.table2.title" :data="this.table2.data" :disclaimer="this.table2.disclaimer"></usc-table> -->
    <usc-videoEmbed :frameTitle="this.video1.frameTitle" :caption="this.video1.caption" :videoSource="this.video1.src"></usc-videoEmbed>
    <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed>
    <div class="body gutter-lg mb">
      <img src="../../../static/post-grad-salaries.jpg" alt="Scatter plot showing post-grad average annual salaries by job function. Investment Banking/Management and Analytics show the highest averages, while Operations/Supply Chain is the lowest." title="Infographic for annual salary" style="width: 100%;" />
    </div>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import Cta from '@/components/Cta'
import videoEmbed from '@/components/videoEmbed'
import table from '@/components/Table'
import CalloutLink from '@/components/CalloutLink'
import twoColumns from '@/components/TwoColumns'
import DataViz from '@/components/DataViz'

export default {
  name: 'Internships',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': Cta,
    'usc-videoEmbed': videoEmbed,
    'usc-table': table,
    'usc-callout-link': CalloutLink,
    'usc-twoColumns': twoColumns,
    'usc-dataviz': DataViz
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Internships and Career Services',
        loResSrc: '../../../static/HeroImages/Advantages-Marshall9.jpg',
        hiResSrc: '../../../static/HeroImages/Advantages-Marshall9.jpg'
      },
      video: {
        caption: 'Career Pathways',
        src: 'https://player.vimeo.com/video/652701332',
        frameTitle: 'Career Pathways'
      },
      video1: {
        caption: 'Why Executives Choose Marshall',
        src: 'https://player.vimeo.com/video/249454520',
        frameTitle: 'Why Executives Choose Marshall'
      },
      calloutLinks: [
        {
          title: 'Accept my offer',
          url: 'https://you.usc.edu/login/',
          urltext: 'Count me in!'
        }
      ],
      dataViz: [{
        color: '#ffcc00',
        labelBold: '40%',
        labelSmall: '3+ Internships'
      },
      {
        color: '#990000',
        labelBold: '34%',
        labelSmall: '2 Internships'
      },
      {
        color: '#cbcbcb',
        labelBold: '26%',
        labelSmall: '1 Internships'
      }
      ],
      table: {
        title: 'Top 25 hiring companies',
        data: [
          {
            left: 'Adobe',
            right: 'Amazon'
          },
          {
            left: 'Apple',
            right: 'Boston Consulting Group'
          },
          {
            left: 'CAA',
            right: 'Deloitte'
          },
          {
            left: 'Disney',
            right: 'DoorDash'
          },
          {
            left: 'Goldman Sachs',
            right: 'JPMorgan Chase & Co.'
          },
          {
            left: 'Lazard',
            right: 'L\'Oreal'
          },
          {
            left: 'McKinsey & Company',
            right: 'NBCUniversal Media, LLC'
          },
          {
            left: 'Nike',
            right: 'Northrop Grumman'
          },
          {
            left: 'PwC',
            right: 'Red Bull'
          },
          {
            left: 'Salesforce',
            right: 'Uber'
          }
        ],
        disclaimer: ''
      },
      table2: {
        title: '25 top internships',
        data: [
          {
            left: 'Aflac',
            right: 'Bank of America'
          },
          {
            left: 'Bank of America Merrill Lynch',
            right: 'Brillstein Entertainment Partners'
          },
          {
            left: 'Capital Group',
            right: 'Cisco Systems, Inc.'
          },
          {
            left: 'Deloitte',
            right: 'Disney'
          },
          {
            left: 'Ernst & Young',
            right: 'Fox'
          },
          {
            left: 'J.P.Morgan',
            right: 'KPMG'
          },
          {
            left: 'Live Nation',
            right: 'Lionsgate'
          },
          {
            left: 'Morgan Stanley',
            right: 'NBCUniversal'
          },
          {
            left: 'Northrop Grumman',
            right: 'Northwestern Mutual'
          },
          {
            left: 'PricewaterhouseCoopers',
            right: 'UBS'
          },
          {
            left: 'USC',
            right: 'Viacom'
          },
          {
            left: 'Warner Bros. Records',
            right: 'Wells Fargo'
          },
          {
            left: 'Wilshire Financial Network',
            right: ''
          }
        ],
        disclaimer: ''
      }
    }
  },
  created () {
    this.$root.setPageHeader('Opportunities', 'Careers and Internships')
  }
}
</script>

<style scoped lang="scss">
@import '~tiny-slider/src/tiny-slider';
</style>



// WEBPACK FOOTER //
// src/pages/advantages/Internships.vue